import { DEFAULT_GC_TIME } from '@/config';
import { DEFAULT_PERIOD, PeriodOption } from '@/config/model';
import { modelVsActualQueries } from '@/duckdb/model-vs-actual';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';
import moment from 'moment';

const fetchActualKpi = async ({
    period = DEFAULT_PERIOD,
    startDate: startDateArg,
    endDate: endDateArg,
}: {
    period: PeriodOption;
    startDate?: string;
    endDate?: string;
}) => {
    const startDate = startDateArg
        ? moment(startDateArg, 'DD-MM-YYYY').format('YYYY-MM-DD')
        : '';
    const endDate = endDateArg
        ? moment(endDateArg, 'DD-MM-YYYY').format('YYYY-MM-DD')
        : '';

    return modelVsActualQueries.getRows({
        type: 'actual',
        period,
        startDate,
        endDate,
    });
};

export const kpiQueryOptions = (
    period: PeriodOption,
    startDate?: string | undefined,
    endDate?: string | undefined,
) => {
    return queryOptions({
        queryKey: [
            'competitor-media-investment-kpi',
            period,
            startDate,
            endDate,
        ],
        queryFn: () => fetchActualKpi({ period, startDate, endDate }),
        placeholderData: keepPreviousData,
        staleTime: Infinity,
        gcTime: DEFAULT_GC_TIME,
    });
};
